import React from 'react'
import { withCookies } from 'react-cookie'
import HomePage from './HomePage/components/HomePage.js'
import LanguagePage from './General/components/LanguagePage.js'
import { InstagramPopup, MailPopup } from './General/components/Popups.js'
import { CSSTransitionGroup } from 'react-transition-group'

class PageController extends React.Component {

	constructor (props) {
		super(props)
		
		// Retrieve Cookies and stored Language 
		this.cookies = props.cookies
		let language = this.cookies.get("language")
		
		this.state = {
			language: this.languageIsValid(language) ? language : "none",
			page: "home",
			instagramPopup: false,
			mailPopup: false
		}

		if (this.state.language === "none") {
			this.detectBrowserLanguage()
		}

		console.log(`Language found in cookies is: ${this.state.language}`)

		// Bind functions to this class
		this.setLanguage = this.setLanguage.bind(this)
		this.navigateTo = this.navigateTo.bind(this)
		this.showPopup = this.showPopup.bind(this)
		this.closeNewWindow = this.closeNewWindow.bind(this)
		this.closePopup = this.closePopup.bind(this)
	}

	render () {

		var body = []

		if (this.state.language === "none" || this.state.page === "language") {
			return <LanguagePage setLanguage={this.setLanguage} />
		} 

		if (this.state.page === "home") {
			body[0] = (<HomePage
					 setLanguage={this.setLanguage} 
					 navigateTo={this.navigateTo}
					 showPopup={this.showPopup}
					 language={this.state.language}
					 />)
		}

		if (this.state.instagramPopup) {
			body[1] = <InstagramPopup language={this.state.language} close={this.closePopup} />
		}

		if (this.state.mailPopup) {
			body[1] = <MailPopup language={this.state.language} close={this.closePopup} />
		}

		return (<CSSTransitionGroup
					transitionName="popup"
			    	transitionEnterTimeout={200}
			    	transitionLeaveTimeout={200}>
					{body}
				</CSSTransitionGroup>)
	}

	detectBrowserLanguage () {
		
		if (window.navigator.language.slice(0, 2) === 'en') {       
  			this.setLanguage("en")
  			console.log(`Browser Language is English!`)
  			return	 
		} 

		if (window.navigator.language.slice(0, 2) === 'de') {
			this.setLanguage("de")
			console.log(`Browser Language is German!`)
			return
		}

		console.log(`Could not detect language: ${window.navigator.language}`)

	}

	languageIsValid (language) {
		switch (language) {
			case "de":
				return true
			case "en":
				return true
			default:
				return false
		}
	}
	pageIsValid (page) {
		switch (page) {
			case "home":
				return true
			case "language":
				return true
			default:
				return false
		}
	}

	setLanguage(language) {
		if (!this.languageIsValid(language)) {return}
		this.setState({language: language})
		this.cookies.set("language",language)
		this.navigateTo("home")
	}

	navigateTo(page) {
		if (!this.pageIsValid(page)) {return}
		this.setState({page: page})
	}

	showPopup(popup) {
		if (popup === "instagram") {
			window.open("https://www.instagram.com/tpk.tpx/")
			this.setState({instagramPopup: true})
			return
		}
		if (popup === "mail") {
			this.newWindow = window.open("mailto:tim.patrick@kakucs.de")
			this.windowTimer = setInterval(this.closeNewWindow,100)
			this.setState({mailPopup: true})
			return
		}
	}

	closeNewWindow () {
		this.newWindow.close()
		clearInterval(this.windowTimer)
	}

	closePopup(popup) {
		if (popup === "instagram") {
			this.setState({instagramPopup: false})
			return
		}
		if (popup === "mail") {
			this.setState({mailPopup: false})
			return
		}
	}

}

export default withCookies(PageController)